import api from "../../infra/api";

class ServSolicitacaoCompartilhamentoDocs {
    async listar (codigoSolicCompart) {
        const response = await api({
            method: "GET",
            url: `/api/v1/SolicitacaoCompartilhamentoDocs?page=1&start=0&limit=999&fields=["Id","CodigoSolicCompart","CodigoDocumento","NomeArquivo","TipoDocumento","CodigoConfiguracaoDoc","CodigoClassificacaoDoc","Aprovado","SolicitacaoCompartilhamento.CodigoVisual","SolicitacaoCompartilhamento"]&sort=[{"property":"CodigoDocumento","direction":"DESC"}]&filter=[{"property":"CodigoSolicCompart","value":"${codigoSolicCompart}","and":true},{"property":"TipoDocumento","operator":"in","value":[3],"and":true}]`
        });

        return response.data;
    }

    async listarPersonalizado (codigoSolicCompart) {
        const response = await api({
            method: "GET",
            url: `/api/v1/SolicitacaoCompartilhamentoDocs?page=1&start=0&limit=999&fields=["Id","CodigoSolicCompart","CodigoDocumento","NomeArquivo","TipoDocumento","SolicitacaoCompartilhamento.CodigoVisual","SolicitacaoCompartilhamento"]&sort=[{"property":"CodigoDocumento","direction":"DESC"}]&filter=[{"property":"CodigoSolicCompart","value":"${codigoSolicCompart}","and":true},{"property":"TipoDocumento","operator":"in","value":[1, 2, 3],"and":true}]`
        });

        return response.data;
    }

    async InserirDocumentoSolicComp(form) {
        const response = await api ({
            method: "POST",
            url: "/api/v1/SolicitacaoCompartilhamentoDocs",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: form
        });

        return response.data;
    }

    async AdicionaranexoViaAnalista(form) {
        const response = await api ({
            method: "POST",
            url: "/api/v1/SolicitacaoCompartilhamentoDocs/AdicionaranexoViaAnalista",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: form
        });

        return response.data;
    }

    async RealizarDownloadDocumento(codigoSolicCompartilhamentoDoc) {
        const response = await api({
            method: "GET",
            url: `api/v1/SolicitacaoCompartilhamentoDocs/RealizarDownloadDocumento/${codigoSolicCompartilhamentoDoc}`
        });

        return response.data;
    }

    async RemoverAnexoSolicCompartilhamentoDocs (codigoSolicCompartilhamentoDoc) {
        const response = await api({
            method: "DELETE",
            url: `api/v1/SolicitacaoCompartilhamentoDocs/RemoverAnexoSolicCompartilhamento/${codigoSolicCompartilhamentoDoc}`
        });

        return response.data;
    }
}

export default new ServSolicitacaoCompartilhamentoDocs();